import ApiService from "../../../services/ApiService";
import {
  formatBirthDate,
  getProfilePhoneForSave,
  isProfilePhoneEmpty,
  transformProfessionsToApiFormat,
} from "./registrationWizardValidation";

const getSaveErrorMessage = (error, fallback = "Could not save phone number.") => {
  const data = error?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  if (data?.message) return data.message;
  if (typeof data?.error === "string") return data.error;
  return fallback;
};

export const isV2SaveSuccess = (result) => result !== false;

export const fetchTherapistForRegistration = () => ApiService.getTherapistForRegistration();

export const saveWelcomeStep = async (
  accountId,
  { firstName, lastName, profilePhotoFile, namesOnFile }
) => {
  if (!namesOnFile) {
    const namesOk = await ApiService.patchTherapistSubAccount(accountId, { firstName, lastName });
    if (!isV2SaveSuccess(namesOk)) {
      return false;
    }
  }

  if (profilePhotoFile) {
    const photoOk = await ApiService.uploadProfilePhoto(accountId, profilePhotoFile);
    if (!isV2SaveSuccess(photoOk)) {
      return false;
    }
  }

  return true;
};

export const saveSecurityStep = async (
  _accountId,
  { password, termsAccepted, needsPassword, needsTerms }
) => {
  if (needsPassword) {
    const passwordOk = await ApiService.updateAccountPassword(password);
    if (!passwordOk) {
      return false;
    }
  }

  if (needsTerms && termsAccepted) {
    const termsOk = await ApiService.acceptTermsAndConditions();
    return !!termsOk;
  }

  return true;
};

export const saveClinicalStep = (accountId, { profession, experienceSince }) =>
  ApiService.saveTherapistProfessions(
    accountId,
    transformProfessionsToApiFormat(profession, experienceSince)
  );

export const saveClinicSettingsStep = (accountId, { languageForPatients }) =>
  ApiService.patchTherapistSubAccount(accountId, { languageForPatients });

export const savePhotoPhoneStep = async (accountId, { email, phone, phoneEdited }) => {
  if (!phoneEdited && isProfilePhoneEmpty(phone)) {
    return { success: true };
  }

  const phonePayload = isProfilePhoneEmpty(phone) ? null : getProfilePhoneForSave(phone);

  try {
    const result = await ApiService.updateAccountEmailOrPhone(accountId, {
      email,
      phone: phonePayload,
    });

    if (result === false) {
      return { success: false, error: "Could not save phone number." };
    }

    return { success: true };
  } catch (error) {
    return { success: false, error: getSaveErrorMessage(error) };
  }
};

/** PATCH /v2/accounts/update-personal-details */
export const saveAboutYouStep = (accountId, {
  gender,
  birthMonth,
  birthDay,
  birthYear,
  clinicianLanguage,
}) => {
  const payload = {
    gender,
    language: clinicianLanguage,
  };
  const birthDate = formatBirthDate(birthMonth, birthDay, birthYear);
  if (birthDate) {
    payload.birthDate = birthDate;
  }
  return ApiService.updatePersonalDetails(accountId, payload);
};
